import styled from 'styled-components'

const StFullScreenModalContainer = styled.div<{ backgroundColor?: string }>`
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'header'
    'main'
    'footer';
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.Colors.Background.Light};
`

const StHeaderContainer = styled.div`
  grid-area: header;
  z-index: 1;
`

const StContentContainer = styled.main`
  grid-area: main;
  display: flex;
  flex-direction: column;
  overflow: auto;
`

const StFooterContainer = styled.div`
  grid-area: footer;
  z-index: 1;
`

export { StContentContainer, StFooterContainer, StFullScreenModalContainer, StHeaderContainer }
